import { Text } from '@/components/atoms/Text';
import { cn } from '@/lib/utils';
import React from 'react';

const ScraperTemplateSelectorSectionHeader = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Text
    variant='label-medium'
    classNames={{
      wrapper: cn('uppercase text-left mt-6 pb-2 font-serif'),
    }}
  >
    {children}
  </Text>
);

export default ScraperTemplateSelectorSectionHeader;
